<template>
  <div id="app" :class="[theme, currentLang]" :dir="direction">
    <div v-if="ShowDetails" class="ShowToUSerBanner">
      <img v-if="step == 2" src="./assets/img/darkL.jpg">
      <img v-if="step == 1" src="./assets/img/lightL.jpg">
    </div>

    <div v-if="!ShowDetails">
      <header-menu @messageSent="toggleTheme" @languageChanged="handleLanguageChange" v-if="IsLogin && !isHomePage && !isAdminRoute"></header-menu>
      <router-view></router-view>
      <menu-bar v-if="IsLogin && !isHomePage && !isAdminRoute"></menu-bar>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'App',
  data() {
    return {
      IsLogin: true,
      ShowDetails: true,
      userGet: 1,

      direction: 'ltr',
      siteSettings: {
        site_logo: null,
        site_name: '',
        site_favicon: null
      }
    };
  },
  computed: {
    isHomePage() {
      return this.$route.path === '/';
    },
    isPublicPage() {
      return this.isHomePage || this.$route.meta.publicPage === true;
    },
    isAdminRoute() {
      return this.$route.path.startsWith('/admin');
    },
    currentLang() {
      return this.$store.state.currentLang;
    },
    theme() {
      return this.$store.state.theme;
    },
    step() {
      return this.theme === 'dark' ? 2 : 1;
    }
  },
  watch: {
    '$route'(to) {
      // Skip processing for admin routes as they're handled by AdminApp.vue
      if (to.path.startsWith('/admin')) {
        this.ShowDetails = false;
        return;
      }
      
      this.relaodPage(to.path);
    },
    currentLang: {
      immediate: true,
      handler(newLang) {
        this.direction = newLang === 'fa' ? 'rtl' : 'ltr';
        document.documentElement.dir = this.direction;
        document.body.dir = this.direction;
        this.$i18n.locale = newLang;
      }
    },
    theme: {
      immediate: true,
      handler(newTheme) {
        this.loadTheme(newTheme);
      }
    }
  },
  methods: {
    ...mapActions(['login']),
    
    async loadSiteSettings() {
      try {
        const axios = require('@/axios');
        const response = await axios.get('/settings/public');
        
        if (response.data && response.data.success) {
          const data = response.data.data;
          
          this.siteSettings = {
            site_logo: data.site_logo || null,
            site_name: data.site_name || 'داده‌پردازان',
            site_favicon: data.site_favicon || null
          };
          
          // Update document title
          document.title = this.siteSettings.site_name;
          
          // Update favicon if available
          if (this.siteSettings.site_favicon) {
            const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = `/storage/settings/${this.siteSettings.site_favicon}`;
            document.getElementsByTagName('head')[0].appendChild(link);
          }
        }
      } catch (error) {
        console.error('Error loading site settings:', error);
      }
    },
    


    handleLanguageChange(lang) {
      this.$store.dispatch('changeLanguage', lang);
      this.$i18n.locale = lang;
    },

    relaodPage(path){
      // If we're on an admin route, don't process further
      if (path.startsWith('/admin')) {
        this.IsLogin = false;
        this.ShowDetails = false;
        return;
      }

      if (this.isPublicPage) {
        this.IsLogin = false;
        this.ShowDetails = false;
        return;
      }
      
      // If on homepage, no login needed
      if(path == "/") {
        this.IsLogin = false;
        this.ShowDetails = false;
        return;
      }
      
      this.IsLogin = true
      if(path == "/login" || path == "/register" || path == "/blocked") {
        this.IsLogin = false
      }

      const userData = localStorage.getItem('user');
      if (userData) {
        this.userGet = JSON.parse(userData);
      }

      if(this.userGet.kv == '0'){
        if (path !== '/' && path !== '/deposit' && path !== '/profile' && path !== '/transaction' && path !== '/verify') {
          this.$router.push('/verify');
        }
      }
    },
    toggleTheme(value) {
      this.$store.dispatch('changeTheme', value);
    },
    loadTheme(theme = this.theme) {
      if (theme === 'light') {
        document.documentElement.classList.remove('dark');
        document.documentElement.classList.add('light');
        document.body.style.backgroundColor = '#f7f4ff';
        document.body.className = 'light';
      }else{
        document.documentElement.classList.remove('light');
        document.documentElement.classList.add('dark');
        document.body.style.backgroundColor = '#121212';
        document.body.className = 'dark';
      }
    },

    async reloadLogin() {
      // Skip login check for admin routes
      if (this.$route.path.startsWith('/admin')) {
        this.ShowDetails = false;
        return;
      }
      
      // If on homepage, no authentication needed
      if (this.isPublicPage) {
        this.ShowDetails = false;
        return;
      }

      const email = localStorage.getItem('email');
      const hashedPassword = localStorage.getItem('password');

      if (hashedPassword) {
        const isPasswordValid = atob(hashedPassword);
        let attempts = 0;
        const maxAttempts = 10;
        const delay = 100;

        while (attempts < maxAttempts) {
          try {
            const response = await this.$store.dispatch('login', { email: email, password: isPasswordValid });

            if (response !== "wrong") {
              this.ShowDetails = false;
              return;
            } else {
              this.ShowDetails = true;
              return;
            }
          } catch (error) {
            this.ShowDetails = true;
          }

          attempts++;
          await new Promise(resolve => setTimeout(resolve, delay));
        }
      } else {
        // If not on homepage and not logged in, redirect to login
        if (this.$route.path !== '/login' && this.$route.path !== '/register') {
          this.$router.push({ name: 'LoginUser' });
        }
        this.ShowDetails = false;
      }
    }
  },
  mounted() {
    this.$store.dispatch('fetchUser');

    this.loadTheme();
    this.loadSiteSettings();
    
    // Skip processing for admin routes
    if (!this.$route.path.startsWith('/admin')) {
      this.relaodPage(this.$route.path);
      
      // If not on homepage, check authentication
      if (!this.isPublicPage) {
        this.reloadLogin();
      }
    } else {
      this.ShowDetails = false;
    }
    
    // Set initial language and direction
    this.direction = this.currentLang === 'fa' ? 'rtl' : 'ltr';
    this.$i18n.locale = this.currentLang;
    document.documentElement.dir = this.direction;
    document.body.dir = this.direction;
    
    localStorage.removeItem('isLoaded');
    setTimeout(() => {
        const isLoaded = localStorage.getItem('isLoaded');
        if (!isLoaded) {
            localStorage.setItem('isLoaded', 'true');
        }
     }, 500);
  }
};
</script>

<style>
.rtl {
  direction: rtl;
}

.ltr {
  direction: ltr;
}
</style>